<template>
  <div class="social-id-number">
    <div class="r-text-intro">פרטים אישיים | כמו שמופיעים בת.ז.</div>
    <div class="r-text-headline-paragraph">
      מספר תעודת זהות
    </div>
    <div class="r-form-row">
      <social-id-number-input
        :social-id-number="idNumber"
        autofocus
        @input="setIdNumber"
        @observe="observe"/>
    </div>

    <default-button label="הבא >" @click="nextPage" :disable="locked" :loading="locked"/>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import WizardPage from '@/mixins/WizardPage';
import DefaultButton from '@/components/styled/DefaultButton';
import SocialIdNumberInput from '@/components/SocialIdNumberInput';

export default {
  name: 'SocialIdNumber',
  components: { SocialIdNumberInput, DefaultButton },
  mixins: [WizardPage],
  data() {
    return {
      biometric: false,
    };
  },
  computed: {
    ...mapState('meitavDash/openFund', ['idNumber']),
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setIdNumber']),
  },
};
</script>
